@for (turn of turns(); track $index) {
	<div class="conversation-turn">
		<div class="user-message">
			<div class="message-bubble user">
				<p>{{ turn.request.userPrompt }}</p>
			</div>
		</div>

		@if (turn.response) {
			<div class="ai-message">
				<div class="message-bubble ai">
					<div [innerHTML]="parseMarkdown(turn.response.explanation)"></div>
					@if (inspect()) {
						<dl class="response-details">
							@if (turn.response.dashboard; as dashboard) {
								<dt>Dashboard</dt>
								<dd class="title">{{ dashboard.dashboard }}</dd>
								@if (dashboard.grouping) {
									<dt>Groeperingen</dt>
									<dd class="mono">
										@for (group of dashboard.grouping; track $index) {
											<p>{{ group }}</p>
										}
									</dd>
								}
								@if (dashboard.filter) {
									<dt>Filter</dt>
									<dd class="mono">
										@for (filter of formatFilters(dashboard.filter); track $index) {
											<p>{{ filter }}</p>
										}
									</dd>
								}
								@for (option of dashboard.options | keyvalue; track option.key) {
									<dt>{{ optionLabel(option.key) }}</dt>
									<dd>{{ option.value }}</dd>
								}
							}
							@if (turn.response.suggestions) {
								<dt>Suggesties</dt>
								<dd>
									<ul class="suggestions">
										@for (suggestion of turn.response.suggestions; track $index) {
											<li>
												<span class="label">{{ suggestion.label }}</span>
												<span class="prompt">{{ suggestion.prompt }}</span>
											</li>
										}
									</ul>
								</dd>
							}
							@if (turn.response.subject) {
								<dt>Onderwerp</dt>
								<dd>{{ turn.response.subject }}</dd>
							}
						</dl>
					}
					@if (inspect()) {
						@if (turn.debug; as debug) {
							<div class="call-details" [class.failure]="debug.failure" [title]="exacteAantallen(debug)">
								@if (debug.failure; as failure) {
									<div class="failure-label">Mislukt: {{ failure }}</div>
								}
								<div>{{ aanroepRegel(debug) }}</div>
								@if (herkomstRegel(debug); as herkomst) {
									<div>{{ herkomst }}</div>
								}
							</div>
						}
					}
					<div class="buttons">
						<button
							class="icon"
							[class.active]="turn.sentiment === 1"
							appTooltip="Goede reactie"
							(click)="feedback.emit({ index: $index, sentiment: 1 })"
							[disabled]="inspect()"
						>
							<app-icon
								name="thumb-up"
								size="small"
								[color]="turn.sentiment === 1 ? 'positive-1' : 'typography-5'"
								hoverColor="positive-1"
							></app-icon>
						</button>
						<button
							class="icon"
							[class.active]="turn.sentiment === -1"
							appTooltip="Slechte reactie"
							(click)="feedback.emit({ index: $index, sentiment: -1 })"
							[disabled]="inspect()"
						>
							<app-icon
								name="thumb-down"
								size="small"
								[color]="turn.sentiment === -1 ? 'error-1' : 'typography-5'"
								hoverColor="error-1"
							></app-icon>
						</button>
						@if (turn.response.dashboard) {
							<button class="icon" (click)="goToDashboardClick(turn.response!.dashboard!)" appTooltip="Ga naar dit dashboard">
								<app-icon name="show" size="small" color="typography-5" hoverColor="typography-3"></app-icon>
							</button>
						}
						@if (toontOpmerkingen()) {
							<button class="icon" (click)="opmerkingToevoegen.emit($index)" appTooltip="Notitie toevoegen">
								<app-icon name="feedback" size="small" color="typography-5" hoverColor="typography-3"></app-icon>
							</button>
						}
					</div>
					@if (turn.feedback) {
						<div class="feedback" [class.positive]="turn.sentiment === 1" [class.negative]="turn.sentiment === -1">
							@if (toontOpmerkingen() && gebruiker(); as naam) {
								<span class="auteur">{{ naam }}:</span>
							}
							<span class="tekst">{{ turn.feedback }}</span>
						</div>
					}
					@if (toontOpmerkingen()) {
						<app-chat-opmerkingen
							[opmerkingen]="opmerkingenVoorTurn($index)"
							(wijzigen)="opmerkingWijzigen.emit($event)"
							(verwijderen)="opmerkingVerwijderen.emit($event)"
						/>
					}
				</div>
			</div>
		}

		@if (!turn.response && $index === turns()!.length - 1) {
			<div class="ai-message loading">
				<div class="message-bubble ai">
					@if (progressMessages().length > 0) {
						<div class="progress-messages">
							@for (message of progressMessages(); track $index) {
								<p class="progress-message">{{ message }}</p>
							}
						</div>
					}
					<div class="loading-animation"><span>.</span><span>.</span><span>.</span></div>
				</div>
			</div>
		}
	</div>
} @empty {
	<div class="empty-conversation">
		<p>Begin een nieuwe conversatie met de CumLaude Assistent door een bericht te typen.</p>
	</div>
}
